<template>
  <div class="welcome text-center">

    <div class="notice-top">
      <div class="jumbotron m-4">
        <h1 class="display-4">Mask Nearby</h1>

        <p class="lead">
          <button class="btn btn-info btn-outline btn-lg danger">공적 마스크 기간이 종료되었습니다</button>
        </p>
        <p class="lead p-3">
          건강보험심사평가원에서 제공받은 마스크 판매정보입니다.<br/>
          이번 주(3월2주)는 서비스의 안정적 운영을 지켜보기 위한 베타서비스 입니다.<br/>
          서비스되는 재고현황 정보는 데이터처리 및 전송으로 인해 실제 현장 판매처의 현황과 5분~10분 정도의 차이가 있습니다. (08:00~23:00)<br/>
          어려운 환경에서도 일선에서 공헌해 주시는 약사님, 우체국 종사자분, 하나로 마트(예정) 분들께도 감사와 응원 드립니다.<br/>
          공적마스크 구매에 관한 정보 -> <a href="http://blog.naver.com/kfdazzang/221839489769">여기</a>
        </p>

        <hr class="my-4">

        <div class="notice">사용성 개선을 위해 계속 수정중입니다.</div>
<!--        <div class="notice2">-->
<!--          <b>업데이트 될 항목</b><br/>-->
<!--          정렬기능-->
<!--        </div>-->
        <div class="contact text-secondary">Contact : masknearby@gmail.com</div>
      </div>
    </div>


  </div>
</template>
<script>
export default {
  name: 'Index',
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .welcome {
  }

  .btn {
    margin-top: 3%;
    margin-bottom: 3%;
  }
  .notice-top {
    margin-top: 2%;
  }

  .notice {
    font-size: 20px;
  }

  .notice2 {
    margin-top: 20px;
    font-size: 15px;
  }

  .contact {
    margin-top: 3%;
  }

  .lead {
    font-size: 17px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue